import { render } from "./BairroSelectModal.vue?vue&type=template&id=76609e47&scoped=true"
import script from "./BairroSelectModal.vue?vue&type=script&lang=js"
export * from "./BairroSelectModal.vue?vue&type=script&lang=js"

import "./BairroSelectModal.vue?vue&type=style&index=0&id=76609e47&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76609e47"]])

export default __exports__